export const PRODUCT_TYPE_BAR = 'Bar';
export const PRODUCT_TYPE_COIN = 'Coin';
export const PRODUCT_TYPE_FRACTIONAL = 'Fractional';
export const PRODUCT_TYPE_BAGS = 'Bags';

export const productTypes = {
  Bar: PRODUCT_TYPE_BAR,
  Coin: PRODUCT_TYPE_COIN,
  Fractional: PRODUCT_TYPE_FRACTIONAL,
  Bags: PRODUCT_TYPE_BAGS,
};

export const productTypesArray = Object.values(productTypes);

export const productLocationTypes = [
  'NewYork',
  'SaltLakeCity',
  'Zurich',
  'London',
  'Sydney',
  'Singapore',
  'Toronto',
  'Ohio',
  'Dallas',
  '',
  '',
  'Delivery',
  'FractionalHoldings',
];

export const productLocationTypesByName = {
  NewYork: 1,
  SaltLakeCity: 2,
  Zurich: 3,
  London: 4,
  Sydney: 5,
  Singapore: 6,
  Toronto: 7,
  Ohio: 8,
  Dallas: 9,
  Delivery: 12,
  FractionalHoldings: 13,
};

export const productMetalType = {
  Gold: 'Gold',
  Silver: 'Silver',
  Platinum: 'Platinum',
  Palladium: 'Palladium',
};

export const LOCATION_TYPE_DELIVERY = 12;
